@if(personDialogDataService.personDetails(); as personDetails){
<kendo-tabstrip #personEditorTabStrip (tabSelect)="onClickTab($event)" class="h-100 p-2">

	<kendo-tabstrip-tab title="Basic Info" [selected]="true">
		<ng-template kendoTabContent>
			<person-basic-info-part></person-basic-info-part>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab title="Emails">
		<ng-template kendoTabContent>
			<person-emails-part></person-emails-part>
		</ng-template>
	</kendo-tabstrip-tab>

	<kendo-tabstrip-tab title="Web Links">
		<ng-template kendoTabContent>
			<weblinks-part [personId]="personDetails.personId" [personName]="personDetails.fullName">
			</weblinks-part>
		</ng-template>
	</kendo-tabstrip-tab>

	<!-- <kendo-tabstrip-tab title="Permissions">
		<ng-template kendoTabContent>
			<p>Permissions</p>
		</ng-template>
	</kendo-tabstrip-tab> -->

	@if(personDetails.demographics){
	<kendo-tabstrip-tab title="Demographics">
		<ng-template kendoTabContent>
			<person-demographics-part></person-demographics-part>
		</ng-template>
	</kendo-tabstrip-tab>
	}

</kendo-tabstrip>
} @else if(isNotProdEnvironment) {
<common-message alertType='info'>
	The record for this person does not exist in the development database yet. Please go to
	programs.eforall.org to see the latest data.
</common-message>
}